<template>
  <div class="customer row row--hover box box--default box--search-member " :class="{ 'disabled': isDisabled }">

    <div class="row__data row__data--small row__data--image ">
      <img v-if="customerThumbnail" :src="customerThumbnail" alt="" />
      <div v-else class="thumbnail thumbnail--customer" :style="color">
        {{ parseInitials(customer.first_name, customer.last_name) }}
      </div>
    </div>
    <div class="row__data row__data--name row__data--large">
      {{ customerName }}
    </div>

    <div class="row__data row__data--address row__data--large" v-if="!selectingStatus">
      {{ `${customerStreet} ${customerAddressNumber}` }}
    </div>
    <template v-if="!selectingStatus">
      <div class="row__data row__data--zip row__data--small">
        {{ customerZip }}
      </div>
      <div class="row__data row__data--city row__data--medium">
        {{ customerCity }}
      </div>
      <div class="row__data  row__data--medium" v-if="isAdded">

        <button class="row__button--add button button--default" :class="{ 'disabled': isDisabled, }"
          @click="removeClicked">
          <span>{{ $t(`customerFamilySearch.${"remove"}`) }}</span>
        </button>
      </div>
      <div class="row__data  row__data--medium" v-else>
        <button class="row__button--add button button--default" :class="{ 'disabled': isDisabled, }" @click="addClicked">
          <span>{{ $t(`customerFamilySearch.${"add"}`) }}</span>
        </button>
      </div>
    </template>
    <template v-else>
      <div class="row__data row__data--city row__data--large">
        <VSelect class="select select--default select--model-dropdown " :options="familyStatuses"
          :reduce="(status) => status.id" :getOptionLabel="getFamilyStatusLabel"
          :placeholder="$t('addPrivateCostumerModal.relation')" @update:modelValue="updateFamilyId"
          :value="familyStatusId" />
      </div>
      <div class="row__data  row__data--small">
        <div class="icon icon__delete" @click="removeClicked" ref="delete">
        </div>

      </div>
    </template>

  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { parseCustomerName, parseInitials } from "@/helpers/entityParsers";
import statics from "@/statics";

defineOptions({
  name: "CustomerFamilySearch"
});

const props = defineProps({
  customer: {
    required: true,
    type: Object,
  },
  selectingStatus: {
    required: true,
    type: Boolean,
  },
  familyStatuses: {
    required: false,
    type: Array,
  },
  familyStatusId: {
    required: false,
    type: Number,
  },
});

const emit = defineEmits(["update:familyStatusId", "clicked-add-customer", "clicked-remove-customer"]);
const { locale } = useI18n();

// State
const isAdded = ref(false);

// Computed Properties
const isDisabled = computed(() => props.customer.members.length > 0);

const customerName = computed(() => parseCustomerName(props.customer));

const customerStreet = computed(() =>
  props.customer.customer_addresses.length
    ? props.customer.customer_addresses[0].street
    : statics.empty
);

const customerAddressNumber = computed(() =>
  props.customer.customer_addresses.length
    ? props.customer.customer_addresses[0].number || ""
    : statics.empty
);

const customerZip = computed(() =>
  props.customer.customer_addresses.length
    ? props.customer.customer_addresses[0].zip
    : statics.empty
);

const customerCity = computed(() =>
  props.customer.customer_addresses.length
    ? props.customer.customer_addresses[0].city
    : statics.empty
);

const customerThumbnail = computed(() => props.customer.photo?.thumbnail || null);

const color = computed(() =>
  props.customer.color
    ? { background: props.customer.color }
    : { background: "#7f8fa4" }
);

const familyStatusLabelKey = computed(() => {
  const normalizedLocale = (locale.value || "").split("-")[0];
  return `long_${normalizedLocale || "de"}`;
});

const getFamilyStatusLabel = (status) => {
  const labelKey = familyStatusLabelKey.value;
  return status?.[labelKey] || status?.long_de || status?.long_en || status?.long_fr || status?.long_it || status?.name || "";
};

// Methods
const updateFamilyId = (event) => {
  emit("update:familyStatusId", event);
};

const addClicked = () => {
  if (!isAdded.value && !isDisabled.value) {
    isAdded.value = true;
    emit("clicked-add-customer", props.customer);
  }
};

const removeClicked = () => {
  if (!isDisabled.value) {
    isAdded.value = false;
    emit("clicked-remove-customer", props.customer);
  }
};
</script>

<style scoped lang="scss">
.customer__dropdown {
  width: 100%;
  background: 0;
}

.input--default,
.select--default {
  background-color: var(--bg-3);
}

.box--search-member {
  box-shadow: 0px 2px 6px var(--shadow-7);
}

.table {

  .row {
    width: 98%;
    margin-left: 1%;
    margin-top: 5px;
    cursor: default;

    &.disabled {
      background: #F2F4F6;
    }

    &:hover {
      background: white;
    }

    .row__button--add {
      width: 100px;
      height: 38px;

      &.disabled,
      &.added {
        background: #B9C2CD;
        box-shadow: inherit;
      }
    }
  }
}
</style>
